import api from './client';

export const cashCountApi = {
  show:        (params?: any) => api.get('/cash-count', { params }),
  save:        (data: any)    => api.post('/cash-count', data),
  differences: (params?: any) => api.get('/cash-count/differences', { params }),
};
